/* Based on To Title Case © 2018 David Gouch | https://github.com/gouch/to-title-case */
/* Added Ignore Words, changed search to only alpha and added () as word separators */

export const toTitleCase = (str) => {
  var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i;
  var ignoreWords = /^(g|kg|lb|mm|cm|m|km|in|mi|yd|ft|h|s|min|lbf|k|divs|ppt|n)$/i;
  var wordSeparators = /([() :–—-])/;

  return str
    ?.split(wordSeparators)
    .map(function (current, index, array) {
      if (
        /* Ignore certain words */
        current.search(ignoreWords) > -1 ||
        /* Ignore any words that include non-alpha characters */
        current.search(/([^A-Za-z])/) > -1 ||
        /* Ignore intentional capitalization */
        current.substr(1).search(/[A-Z]|\../) > -1
      ) {
        return current;
      }

      /* Ignore intentional capitalization */
      if (current.substr(1).search(/[A-Z]|\../) > -1) {
        return current;
      }

      if (
        /* Check for small words */
        current.search(smallWords) > -1 &&
        /* Skip first and last word */
        index !== 0 &&
        index !== array.length - 1 &&
        /* Ignore title end and subtitle start */
        array[index - 3] !== ':' &&
        array[index + 1] !== ':' &&
        /* Ignore small words that start a hyphenated phrase */
        (array[index + 1] !== '-' || (array[index - 1] === '-' && array[index + 1] === '-'))
      ) {
        return current.toLowerCase();
      }

      /* Ignore URLs */
      if (array[index + 1] === ':' && array[index + 2] !== '') {
        return current;
      }

      /* Capitalize the first letter */
      return current.replace(/([A-Za-z])/, function (match) {
        return match.toUpperCase();
      });
    })
    .join('');
};
